import { Checkbox, CheckboxProps, Chip, chipClasses, useTheme } from '@mui/material';

interface IStatusCheckboxProps extends CheckboxProps {
  label: string;
}

interface IStatusChipProps {
  label: string;
  checked?: boolean;
}

const StatusChip = ({ label, checked }: IStatusChipProps) => {
  const theme = useTheme();
  return (
    <Chip
      sx={{
        minWidth: {
          xs: 50,
          sm: 61,
        },
        [`&.${chipClasses.outlined}`]: {
          color: theme.palette.text.secondary,
        },
        [`&.${chipClasses.filled}`]: {
          padding: theme.spacing(0.5),
        },
      }}
      color={checked ? 'primary' : 'default'}
      variant={checked ? 'filled' : 'outlined'}
      label={
        <div className='flex items-center'>
          <span className='text-sm font-semibold'>{label}</span>
        </div>
      }
    />
  );
};

const StatusCheckbox = ({ label, ...props }: IStatusCheckboxProps) => {
  return (
    <Checkbox
      sx={{ padding: 0 }}
      disableRipple
      inputProps={{ 'aria-label': label }}
      checkedIcon={<StatusChip label={label} checked />}
      icon={<StatusChip label={label} />}
      {...props}
    />
  );
};

export default StatusCheckbox;
